<template>
  <v-list-item link :to="item.pgmId" active-class="secondary">
    <v-list-item-icon>
      <!-- <v-icon color="nav_title">
        ${{ item.icon }}
      </v-icon> -->
      
    </v-list-item-icon>
    <v-list-item-title class="nav_title--text">
      <!-- {{ $t(item.menuCode) }} -->
      {{ item.ename }}
    </v-list-item-title>
  </v-list-item>
</template>

<script>
  export default {
    name: 'DefaultListItem',
    props: {
      item: {
        type: Object,
        default: () => ({}),
      }
    }
  }
</script>